import React from 'react';
import { Button, Tooltip } from 'antd';
import humanizeUtil from '@utils/humanizeUtil';
import { CURRENT_PRODUCT_MODE, isAppModule } from '@utils/constants';
import { WarningOutlined } from '@ant-design/icons';
import SettingsIcon from '@icons/ovb/settings.svg';
import SettingsActiveIcon from '@icons/ovb/settings-active.svg';
import formatGaugeChartData from '@utils/overview/gaugeChart';
import Chart from '@src/components/overview-dashboard/common/chart/Chart';
import { getMetricMetaByKey } from '@src/utils/metrics';
import kpiStore from '@src/globalStore/kpiStore';
import { Trend } from '@components/common';
import { SPI_LABEL, SPI_METRIC } from './constants';
import {
  SPIWidgetWrapper,
  WidgetNumberWrapper,
  WidgetTextWrapper,
  WidgetTitle,
  SPIScoreWrapper,
} from '../styled';
import { getTextColor } from '@src/utils/kpi/tools';
import { getDodDiff } from '@src/components/metrics-panel-hz/utils/calculateDodTotal';

const THRESHOLD_SERVICE_STATUS_TEXT = `Showing Conviva Good since custom KPIs are not available right now.`;

const SPIWidget = ({
  data = {},
  dodData = {},
  currentKpi,
  selectedChartMetric,
  onWidgetCardClick: onSPIClick,
  showTrend = false,
}) => {
  let isThresholdServiceDown = false;
  if (currentKpi === '') {
    isThresholdServiceDown = true;
  }
  const metricKey = SPI_METRIC;
  const spiScore = data[metricKey];
  const spiColor = getTextColor(spiScore || 0);
  const SPIText = SPI_LABEL[CURRENT_PRODUCT_MODE];
  const kpiName = `${SPIText}: ${isThresholdServiceDown ? 'Conviva Good' : currentKpi?.kpiName}`;
  const setIsKpiDrawerOpen = kpiStore((state: any) => state.setIsKpiDrawerOpen);
  const isKpiDrawerOpen = kpiStore((state: any) => state.isKpiDrawerOpen);

  const handleKpiDrawerChange = () => {
    setIsKpiDrawerOpen(!isKpiDrawerOpen);
  };
  const metricInfo = getMetricMetaByKey({ metricKey });
  const spiDodData = dodData[metricKey];

  const trend = React.useMemo(() => {
    return getDodDiff(spiScore, spiDodData);
  }, [spiDodData, spiScore]);

  const renderGauge = () => {
    const height = '64px';
    const width = '70px';
    const chartOption = formatGaugeChartData(humanizeUtil(spiScore, '').humanizedNumber);

    if (chartOption) {
      return <Chart option={chartOption} height={height} width={width} />;
    } else {
      return null;
    }
  };

  return (
    <>
      <SPIWidgetWrapper
        onClick={() => onSPIClick(metricKey, spiScore, kpiName)}
        highlight={metricKey === selectedChartMetric}
      >
        {renderGauge()}
        <WidgetTextWrapper style={{ marginRight: '10px', width: 'max-content' }}>
          <WidgetTitle>
            <span>{kpiName}</span>
            {isThresholdServiceDown ? (
              <Tooltip title={THRESHOLD_SERVICE_STATUS_TEXT}>
                <WarningOutlined
                  style={{
                    color: 'grey',
                  }}
                />
              </Tooltip>
            ) : null}
          </WidgetTitle>
          <SPIScoreWrapper isSettingsPresent={isAppModule}>
            <WidgetNumberWrapper style={{ color: spiColor }}>
              {humanizeUtil(spiScore, '').humanizedNumber}
              {showTrend && (
                <Trend
                  value={trend}
                  style={{ textAlign: 'left', paddingLeft: 4 }}
                  reverse={metricInfo.reverse}
                />
              )}
            </WidgetNumberWrapper>
            {isAppModule && (
              <Button
                type="text"
                disabled={isThresholdServiceDown}
                onClick={() => handleKpiDrawerChange()}
                style={{
                  backgroundColor: isKpiDrawerOpen ? '#4d7eff' : '#fff',
                  padding: '3px 3px 0px 3px',
                  borderRadius: '5px',
                }}
                icon={isKpiDrawerOpen ? <SettingsActiveIcon /> : <SettingsIcon />}
              />
            )}
          </SPIScoreWrapper>
        </WidgetTextWrapper>
      </SPIWidgetWrapper>
    </>
  );
};

export default SPIWidget;
